export default "https://cdn-static.gokick.com/assets/efda86aac2f53028585758eeb3b3c0048c8387b3/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";